import { useTranslation } from 'next-i18next'
import * as yup from 'yup'
import { ForgotPasswordFormValues } from 'components/Auth/ForgotPasswordFormValues'

export const ForgotPasswordFormSchema = () => {
  const { t } = useTranslation('errors', { keyPrefix: 'validation' })

  return yup.object<ForgotPasswordFormValues>().shape({
    email: yup.string().email(t('email')).required(t('required'))
  })
}

export const ForgotPasswordAPISchema = yup
  .object<ForgotPasswordFormValues>()
  .shape({
    email: yup.string().email().required(),
    redirectUrl: yup.string().required()
  })
